import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import styles from "./load-more.module.css";
import { Trans } from "@coworker/locales";

interface LoadMoreProps {
  totalCount?: number;
  loadedItemsCount: number;
  onLoadMoreClick: () => void;
  isFetching?: boolean;
}

export const LoadMore = ({
  totalCount,
  loadedItemsCount,
  onLoadMoreClick,
  isFetching,
}: LoadMoreProps) => {
  return (
    <div className={styles["load-more"]}>
      <div className={styles["content-wrapper"]}>
        {totalCount && (
          <>
            <div className={styles["counts"]}>
              <Trans i18nKey={"loadMoreCountsString"}>
                {{ loadedItemsCount }}
                {{ totalCount }}
              </Trans>
            </div>
            <div className={styles["bar"]}>
              <div
                className={styles["progress"]}
                style={{ width: `${(loadedItemsCount / totalCount) * 100}%` }}
              />
            </div>
          </>
        )}
        <FixaButton
          onClick={onLoadMoreClick}
          text={<Trans>loadMore</Trans>}
          type="secondary"
          size="small"
          fluid
          loading={isFetching ?? false}
        />
      </div>
    </div>
  );
};
